import React, { PropTypes } from 'react';
import Helmet from 'react-helmet';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

const propTypes = {
  pageTitle: PropTypes.string,
  intl:      intlShape.isRequired,
  libraryFullName: PropTypes.string.isRequired,
  twitterHandle: PropTypes.string
};

export class DocumentHeadContainer extends BcReactComponent {
  render() {
    const { intl, libraryFullName, twitterHandle } = this.props;
    const title = intl.formatMessage({ id: 'pageTitleTemplate' }, { libraryName: libraryFullName, pageTitle: this.props.pageTitle });
    const meta = [
      { property: 'og:title', content: title },
      { property: 'twitter:title', content: title },
      { property: 'og:site_name', content: libraryFullName },
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1' },
      ...(twitterHandle ? [{ property: 'twitter:creator', content: `@${twitterHandle}` }] : [])
    ];
    return (
      <Helmet
        title={title}
        defaultTitle={intl.formatMessage({ id: 'defaultPageTitle' }, { libraryName: libraryFullName })}
        meta={meta} />
    );
  }
}

DocumentHeadContainer.propTypes = propTypes;

function mapStateToProps(state) {
  const library = currentLibrarySelector(state);
  return {
    libraryFullName: library.get('fullName'),
    currentLanguage: state.getIn(['localization', 'currentLanguage']),
    twitterHandle: library.get('twitterHandle')
  };
}

export default injectIntl(connect(mapStateToProps)(DocumentHeadContainer));



// WEBPACK FOOTER //
// ./app/containers/DocumentHeadContainer.jsx